import React, { useMemo, useState } from "react";
import "./styles.less";
import EchartsBase from "../../../../components/EchartsBase";
import * as echarts from "echarts";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { getCookie } from "../../../..//utils";

const format = (item) => {
  const isEnglish = getCookie("_authing_lang") === "en-US";
  if (item === 0) {
    return "0";
  }
  if (item === 50) {
    return isEnglish ? "10k+" : "万+";
  }
  if (item === 100) {
    return isEnglish ? "100k+" : "十万+";
  }
  if (item === 150) {
    return isEnglish ? "1m+" : "百万+";
  }
  if (item === 200) {
    return isEnglish ? "5m+" : "五百万+";
  }
  if (item === 250) {
    return isEnglish ? "10m+" : "千万+";
  }
};

const optionBase = (tooltip) => {
  return {
    backgroundColor: "transparent",
    grid: {
      left: 0,
      right: 0,
      top: 20,
      bottom: 100,
    },
    yAxis: tooltip
      ? {
          type: "value",
          min: 0,
          max: 250,
          splitLine: {
            show: false,
          },
          axisLabel: {
            formatter: format,
          },
        }
      : {
          type: "value",
          min: 0,
          max: 250,
          splitLine: {
            lineStyle: {
              color: "#4E5969",
              type: "dashed",
            },
          },
          axisLabel: {
            formatter: format,
          },
        },
    xAxis: {
      type: "category",
      data: ["", ""],
      boundaryGap: false,
    },
  };
};

const areaStyle = {
  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
    {
      offset: 0,
      color: "rgba(57, 182, 255, 0.4)",
    },
    {
      offset: 1,
      color: "rgba(57, 106, 255, 0.1)",
    },
  ]),
};
const areaStyle2 = {
  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
    {
      offset: 0,
      color: "rgba(49, 216, 169, 0.4)",
    },
    {
      offset: 1,
      color: "rgba(49, 216, 169, 0.1)",
    },
  ]),
};

export const ManufacturingChart = () => {
  const { t } = useTranslation();
  const text = useMemo(() => {
    return {
      title: t("manufacturing.chart.title"),
      content: [
        {
          title: t("manufacturing.chart.content1.title"),
          subtitle: t("manufacturing.chart.content1.subtitle"),
          desc: t("manufacturing.chart.content1.desc"),
          tooltip: {
            title: t("manufacturing.chart.content1.tooltip.title"),
            content: t("manufacturing.chart.content1.tooltip.content"),
          },
        },
        {
          title: t("manufacturing.chart.content2.title"),
          subtitle: t("manufacturing.chart.content2.subtitle"),
          desc: t("manufacturing.chart.content2.desc"),
          tooltip: {
            title: t("manufacturing.chart.content2.tooltip.title"),
            content: t("manufacturing.chart.content2.tooltip.content"),
          },
        },
        {
          title: t("manufacturing.chart.content3.title"),
          subtitle: t("manufacturing.chart.content3.subtitle"),
          desc: t("manufacturing.chart.content3.desc"),
          tooltip: {
            title: t("manufacturing.chart.content3.tooltip.title"),
            content: t("manufacturing.chart.content3.tooltip.content"),
          },
        },
        {
          title: t("manufacturing.chart.content4.title"),
          subtitle: t("manufacturing.chart.content4.subtitle"),
          desc: t("manufacturing.chart.content4.desc"),
          tooltip: {
            title: t("manufacturing.chart.content4.tooltip.title"),
            content: t("manufacturing.chart.content4.tooltip.content"),
          },
        },
      ],
      legend: [
        {
          color: "#396AFF",
          text: t("manufacturing.chart.legend1.text"),
        },
        {
          color: "#65E2BF",
          text: t("manufacturing.chart.legend2.text"),
        },
      ],
      chartTitle: t("manufacturing.chart.chartTitle"),
    };
  }, [t]);
  const [hoverflag, setHoverFlag] = useState([false, false, false, false]);
  return (
    <div style={{ background: "#242933" }}>
      <section className="manufacturing-chart basic-column">
        <h1 className="manufacturing-title basic-title">{text.title}</h1>
        <div className="manufacturing-chart-content basic-column">
          <div className="chart-title-warp">
            <div className="chart-title">{text.chartTitle}</div>
            <div className="legend-wrapper">
              <div className="legend">
                {text.legend.map((item) => (
                  <div className="legend-item" key={item.text}>
                    <i style={{ background: item.color }}></i>
                    <div>{item.text}</div>
                  </div>
                ))}
              </div>
              <div className="legend-desc">
                {t("manufacturing.chart.legendDesc")}
              </div>
            </div>
          </div>
          <ul className="content-main">
            <li
              className={classNames("content-main-item", {
                active: hoverflag[0],
              })}
              onMouseEnter={() => {
                setHoverFlag([true, false, false, false]);
              }}
              onMouseLeave={() => {
                setHoverFlag([false, false, false, false]);
              }}
            >
              <div style={{ width: "100%", height: "100%" }}>
                <EchartsBase
                  option={{
                    ...optionBase(hoverflag[0]),
                    series: [
                      {
                        data: [0, 40],
                        type: "line",
                        smooth: true,
                        areaStyle,
                      },
                    ],
                    grid: {
                      left: 55,
                      right: 0,
                      top: 20,
                      bottom: 100,
                    },
                  }}
                ></EchartsBase>
                <section className="content-main-text">
                  <div className="content-main-text-left">
                    {text.content[0].title}
                  </div>
                  <div className="content-main-text-right">
                    <p className="subtitle">{text.content[0].subtitle}</p>
                  </div>
                </section>
                <section
                  className="chart-tooltip"
                  style={{
                    left: 50,
                  }}
                >
                  <div className="title">{text.content[0].tooltip.title}</div>
                  <ul className="content">
                    <li>{text.content[0].tooltip.content}</li>
                  </ul>
                </section>
              </div>
            </li>
            <li
              className={classNames("content-main-item", {
                active: hoverflag[1],
              })}
              onMouseEnter={() => {
                setHoverFlag([false, true, false, false]);
              }}
              onMouseLeave={() => {
                setHoverFlag([false, false, false, false]);
              }}
            >
              <div style={{ width: "100%", height: "100%" }}>
                <EchartsBase
                  option={{
                    ...optionBase(hoverflag[1]),
                    series: [
                      {
                        data: [40, 70],
                        type: "line",
                        smooth: true,
                        areaStyle: areaStyle,
                      },
                      {
                        data: [80, 140],
                        type: "line",
                        smooth: true,
                        areaStyle: areaStyle2,
                      },
                    ],
                  }}
                ></EchartsBase>
                <section className="content-main-text">
                  <div className="content-main-text-left">
                    {text.content[1].title}
                  </div>
                  <div className="content-main-text-right">
                    <p className="subtitle">{text.content[1].subtitle}</p>
                  </div>
                </section>
                <section className="chart-tooltip">
                  <div className="title">{text.content[1].tooltip.title}</div>
                  <ul className="content">
                    <li>{text.content[1].tooltip.content}</li>
                  </ul>
                </section>
              </div>
            </li>
            <li
              className={classNames("content-main-item", {
                active: hoverflag[2],
              })}
              onMouseEnter={() => {
                setHoverFlag([false, false, true, true]);
              }}
              onMouseLeave={() => {
                setHoverFlag([false, false, false, false]);
              }}
            >
              <div style={{ width: "100%", height: "100%" }}>
                <EchartsBase
                  option={{
                    ...optionBase(hoverflag[2]),
                    series: [
                      {
                        data: [70, 105],
                        type: "line",
                        smooth: true,
                        areaStyle: areaStyle,
                      },
                      {
                        data: [140, 190],
                        type: "line",
                        smooth: true,
                        areaStyle: areaStyle2,
                      },
                    ],
                  }}
                ></EchartsBase>
                <section className="content-main-text">
                  <div className="content-main-text-left">
                    {text.content[2].title}
                  </div>
                  <div className="content-main-text-right">
                    <p className="subtitle">{text.content[2].subtitle}</p>
                  </div>
                </section>
                <section className="chart-tooltip">
                  <div className="title">{text.content[2].tooltip.title}</div>
                  <ul className="content">
                    <li>{text.content[2].tooltip.content}</li>
                  </ul>
                </section>
              </div>
            </li>
            <li
              className={classNames("content-main-item", {
                active: hoverflag[3],
              })}
              onMouseEnter={() => {
                setHoverFlag([false, false, true, true]);
              }}
              onMouseLeave={() => {
                setHoverFlag([false, false, false, false]);
              }}
            >
              <div style={{ width: "100%", height: "100%" }}>
                <EchartsBase
                  option={{
                    ...optionBase(hoverflag[3]),
                    series: [
                      {
                        data: [105, 120],
                        type: "line",
                        smooth: true,
                        areaStyle: areaStyle,
                      },
                      {
                        data: [190, 250],
                        type: "line",
                        smooth: true,
                        areaStyle: areaStyle2,
                      },
                    ],
                  }}
                ></EchartsBase>
                <section className="content-main-text">
                  <div className="content-main-text-left">
                    {text.content[3].title}
                  </div>
                  <div className="content-main-text-right">
                    <p className="subtitle">{text.content[3].subtitle}</p>
                  </div>
                </section>
              </div>
            </li>
          </ul>
        </div>
      </section>
    </div>
  );
};
